export default {
  name: 'MfNotificationsBadge',
  props: {
    /**
     * Number of notifactions
     */
    notificationsCounter: {
      type: Number,
      default: 0
    },
    /**
     * Size of the notification badge (x-small, small, medium, large)
     */
    size: {
      type: String,
      default: 'medium',
      validator: value => ['x-small', 'small', 'medium', 'large'].includes(value)
    }
  },
  computed: {
    sizeClass() {
      return `notification-circle--${this.size}`;
    }
  }
};